export const PROMO_CARD_ACTION_BUTTON_TEXT = 'Подробнее';
